<template>
  <div
    v-if="value"
    class="modal"
    @click.self="$emit('input', !value)"
  >
    <div class="modal__window">
      <div class="modal__header">
        <h2 class="modal__title">{{ title }}</h2>
        <div
          class="modal__close"
          @click="$emit('input', !value)"
        />
      </div>

      <div class="modal__body">
        <div class="modal__text">{{ text }}</div>
        <button
          class="modal__confirm"
          @click="onConfirm"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    buttonText: {
      type: String,
      default: 'Confirm'
    }
  },

  methods: {
    onConfirm() {
      this.$emit('confirm')
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../css/vars.styl'
@import '../css/mixins.styl'

.modal
  font-family 'Quicksand', sans-serif
  position fixed
  top 0
  right 0
  bottom 0
  left 0
  display flex
  justify-content center
  align-items center
  background rgba(0, 0, 0, 0.9)

  &__window
    width 400px
    max-width 100%
    margin 15px
    border-radius 5px
    background-color $primary
    padding 24px
    box-shadow $elevation

  &__header
    display flex
    margin-bottom 24px

  &__title
    flex 1
    font-weight 400

  &__confirm
    button()

  &__text
    margin-bottom 16px

  &__close
    control_button()
    margin -8px -8px 0 0
</style>
